module.exports = __webpack_public_path__ + "static/media/(LH)-Prata-08.e9526792.jpg";